import {
    Box,
    Flex,
    Text,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import React from 'react'
import {useIntl, FormattedNumber} from 'react-intl'
import PropTypes from 'prop-types'
import {useItemVariant} from '@salesforce/retail-react-app/app/components/item-variant'
import {remCalc} from '../../theme/_utils'

const ItemPriceCustom = ({
    currency,
    basePrice,
    direction = 'column',
    directionOmnibus = 'column',
    showOmnibusLabel = true,
    styleVariant = '',
}) => {
    const intl = useIntl()
    const variant = useItemVariant()
    const styles = useStyleConfig('ItemPriceCustom', {variant: styleVariant})

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const {price, priceAfterItemDiscount, priceAdjustments} = variant
    const priceAfterItemDiscountWithoutWeeeFee =
        priceAfterItemDiscount > price
            ? priceAfterItemDiscount -
              priceAdjustments
                  ?.filter((adj) => adj?.promotionId === 'weeeFee')
                  .reduce((sum, adj) => sum + (adj.price || 0), 0)
            : priceAfterItemDiscount

    return (
        <Flex flexDirection={direction} gap={remCalc(8)}>
            <Box {...styles.mediumText}>
                <FormattedNumber
                    style="currency"
                    currency={currency}
                    value={
                        priceAfterItemDiscountWithoutWeeeFee !== null &&
                        priceAfterItemDiscountWithoutWeeeFee !== undefined
                            ? priceAfterItemDiscountWithoutWeeeFee
                            : price
                    }
                />
            </Box>
            {priceAfterItemDiscountWithoutWeeeFee < price && (
                <Flex {...styles.omnibus} flexDirection={directionOmnibus}>
                    <Text {...styles.omnibusPrice}>
                        {showOmnibusLabel && (
                            <FormattedNumber
                                style="currency"
                                currency={currency}
                                value={basePrice || price}
                            />
                        )}
                    </Text>
                    {showOmnibusLabel && (
                        <Text>
                            {intl.formatMessage({
                                id: 'mini_cart.item.omnibus',
                                defaultMessage: 'Empfohlener Preis',
                            })}
                        </Text>
                    )}
                </Flex>
            )}
        </Flex>
    )
}
ItemPriceCustom.propTypes = {
    currency: PropTypes.string.isRequired,
    basePrice: PropTypes.number,
    styles: PropTypes.object,
    directionOmnibus: PropTypes.string,
    direction: PropTypes.string,
    showOmnibusLabel: PropTypes.bool,
    styleVariant: PropTypes.string,
}

export default ItemPriceCustom
